export const environment = {
  production: false,
appTitle: 'Pilexos',
  environmentMessage: 'Test',
  //apiRoot: "https://localhost:44368/api/v1",
  //apiRoot: "https://localhost:44370/api/v1",

  //apiRoot: "https://devware-cap-test.azurewebsites.net/api/v1",
  //apiRoot: "https://pilexos-test-api.azurewebsites.net/api/v1",

  environment: getEnvironment(EnvironmentNames.test),
  altEnvironment: getEnvironment(EnvironmentNames.feature),

  alternateApiRoots: {
    'reporting': 'https://shared-api.devwareapps.com/api/v1'
  },

  tenantKey: '16970b66-9788-4e12-aeb3-36bda56bd32f',

  allowConfiguration: true,
  enabledConsoleLogging: true,

  googleAnalyticsTrackingToken: null,
  showContactUs: true,
  contactUsEmail: 'noreply@devwareinc.com',
  enableConsoleLogging: true,
  disabledUserInactvityTimeout: false
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error';  // Included with Angular CLI.import { getEnvironment } from './all-environments-config.model';

import { getEnvironment } from './all-environments-config.model';
import { EnvironmentNames } from './models/environment-names.enum';
